import { init } from '@sentry/nextjs';
import { defaultConfig } from './defaultConfig';

export const initSentryOnClient = () => {
  init({
    ...defaultConfig,
    allowUrls: [/localhost/, /scorenco\.com/],
    denyUrls: [
      // Chrome extensions
      /^chrome:\/\//i,
      /chrome-extension:/i,
      /extensions\//i,

      // Locally saved copies
      /file:\/\//i,

      // Safari extensions.
      /safari-web-extension:/i,
      /safari-extension:/i,

      // Erreurs lié à Flashtalking (ads server)
      /pageFold/,
      /ftUtils/,

      // Erreurs lié aux pubs direct-score
      /\/gtm\.js/,
      /\.taboola\.com/,
      /gpt\/.*pubads_impl\.js/,
      /googletag-drs/,
      /gpt\.js/,

      // Pubstack (régie publicitaire Ouest-France)
      /pbstck\.com/,
      /pubstack/i,

      // Autres régies publicitaires
      /doubleclick\.net/,
      /googlesyndication\.com/,
      /adnxs\.com/,
      /criteo\.com/,
      /smartadserver\.com/,
      /\.amazon-adsystem\.com/,
      /\.optidigital\.com/,
    ],
    ignoreErrors: [
      // https://github.com/getsentry/sentry-javascript/issues/3440#issuecomment-1233146122
      /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+$/,
      // https://stackoverflow.com/a/50387233/14809536
      /^ResizeObserver loop limit exceeded$/,
      // https://issuetracker.google.com/issues/396043331?pli=1
      /^Can't find variable: gmo$/,

      // Erreurs publicitaires communes
      /adsbygoogle/i,
      /prebid/i,
      /header-bidding/i,
      /Cannot read properties of null.*googletag/i,
      /googletag is not defined/i,
      /pbjs is not defined/i,
    ],
    beforeSend(event, hint) {
      const error = hint?.originalException;

      if (
        error instanceof TypeError &&
        error.message?.includes('storage.googleapis.com')
      ) {
        return null;
      }

      return defaultConfig.beforeSend
        ? defaultConfig.beforeSend(event, hint)
        : event;
    },
    beforeBreadcrumb(breadcrumb, hint) {
      if (
        breadcrumb.category === 'fetch' &&
        typeof breadcrumb.data?.url === 'string' &&
        breadcrumb.data.url.includes('storage.googleapis.com')
      ) {
        return null;
      }

      return defaultConfig.beforeBreadcrumb
        ? defaultConfig.beforeBreadcrumb(breadcrumb, hint)
        : breadcrumb;
    },
  });
};
